export const ADD_BALANCE_ALERT = '[BalanceAlerts] add toast';
export const DISPOSE_BALANCE_ALERT = '[BalanceAlerts] dispose toast';
